import styled from 'styled-components'
import { Button as ButtonV2, Textarea } from '@baseV2'
import { Devices, Spacings, Text } from '@styles'

export const Page = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100%;
	background: ${({ theme }) => theme.colors.surface.page};
	font-family: ${({ theme }) => theme.fontFamily?.inter || "'Inter', sans-serif"};
`

export const Body = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	// padding: ${Spacings.SPACING_2B};
	overflow-x: hidden;
	overflow-y: auto;
	min-width: 0;
	// padding-bottom: ${Spacings.SPACING_2B};
	// border:1px solid red;
`

export const Card = styled.div`
	background: ${({ theme }) => theme.colors.surface.card};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: 5px;
	padding: ${Spacings.SPACING_3B};	
	min-width: 0;
	max-width: 100%;

	@media ${Devices.tablet} {
		padding: ${Spacings.SPACING_4B};
	}
`

export const SectionTitle = styled.h3`
	margin: 0 0 ${Spacings.SPACING_3B} 0;
	font-size: ${Text.LARGE};
	font-weight: ${Text.BOLD_700};
	color: ${({ theme }) => theme.colors.text.primary};
`

// Top summary strip: order-in-kg checkbox + Total Amount (FOR).
export const TopBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	flex-wrap: wrap;
`

export const CheckRow = styled.label`
	display: inline-flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
	cursor: pointer;
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const TotalBox = styled.div`
	display: flex;
	align-items: baseline;
	gap: ${Spacings.SPACING_2B};
`

export const TotalLabel = styled.span`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.colors.text.secondary};
`

export const TotalValue = styled.span`
	font-size: ${Text.M_LARGE};
	font-weight: ${Text.BOLD_700};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const HeaderButtons = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	flex-wrap: wrap;
	gap: ${Spacings.SPACING_2B};
`

// Add Charge / Add Item buttons — same height as the enquiry Create step (HeaderButton).
export const HeaderButton = styled(ButtonV2)`
	height: ${Spacings.SPACING_9B};
	box-sizing: border-box;
`

// Bordered summary pill (Items / Weight / Total), matching the enquiry Create step box.
export const SummaryBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: ${Spacings.SPACING_5B};
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.colors.surface.card};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.sm};

	@media ${Devices.laptop} {
		flex-wrap: nowrap;
	}
`

export const SummaryItem = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	padding-right: ${Spacings.SPACING_5B};
	border-right: 1px solid ${({ theme }) => theme.colors.border.default};
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.colors.text.secondary};
	white-space: nowrap;

	&:last-child {
		border-right: none;
		padding-right: 0;
	}

	& > strong {
		font-weight: ${Text.BOLD_500};
		color: ${({ theme }) => theme.colors.brand.primary};
	}
`

export const SectionHeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	margin-bottom: ${Spacings.SPACING_3B};
	flex-wrap: wrap;

	/* Keep the "Add Items" heading vertically centered with the row controls. */
	& > h3 {
		margin-bottom: 0;
	}
`
export const FieldRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: ${Spacings.SPACING_3B};

	& > * {
		flex: 1 1 180px;
		min-width: 0;
	}
	& > *:first-child {
		flex: 3 1 320px;
	}

	@media ${Devices.laptop} {
		flex-wrap: nowrap;
	}

	label {
		font-size: ${Text.SMALL};
		text-transform: none;
		font-weight: ${Text.REGULAR};
		color: ${({ theme }) => theme.colors.text.secondary};
		letter-spacing: 0.012em;
	}
`

// --- Billing Details cards (reference design: icon + title + Edit link, GST pill, bordered card) ---
export const BillingGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: ${Spacings.SPACING_3B};
	// margin-top: ${Spacings.SPACING_3B};
	min-width: 0;
	max-width: 100%;

	@media (max-width: 720px) {
		grid-template-columns: 1fr;
	}
`

export const AddrCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_4B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	background: ${({ theme }) => theme.colors.surface.card};
`

export const AddrHeader = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};

	& > svg {
		color: ${({ theme }) => theme.colors.brand.primary};
		font-size: ${Text.X_LARGE};
	}
`

export const AddrTitle = styled.span`
	font-size: ${Text.LARGE};
	font-weight: ${Text.BOLD_700};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const EditLink = styled.button`
	margin-left: auto;
	display: inline-flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	border: none;
	background: transparent;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.brand.primary};
	font-family: inherit;
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};

	& > svg {
		font-size: ${Text.LARGE};
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`

export const GstPill = styled.span`
	align-self: flex-start;
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_3B};
	border-radius: ${({ theme }) => theme.radius.full};
	background: ${({ theme }) => theme.colors.brand.subtle};
	border: 1px solid ${({ theme }) => theme.colors.brand.muted};
	color: ${({ theme }) => theme.colors.brand.primary};
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};
`

export const AddrId = styled.span`
	font-size: ${Text.BASE_SMALL};
	color: ${({ theme }) => theme.colors.text.secondary};
`

export const AddrLine = styled.div`
	font-size: ${Text.MEDIUM};
	line-height: ${Text.LINE_HEIGHT_MAX};
	color: ${({ theme }) => theme.colors.text.secondary};
`

export const AddrStrong = styled.div`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const TermList = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	margin-top: ${Spacings.SPACING_1B};
	font-size: ${Text.MEDIUM};
	line-height: ${Text.LINE_HEIGHT_MAX};
	color: ${({ theme }) => theme.colors.text.secondary};
`

// Delivery dates stacked vertically (one field per row), matching the previous layout.
export const DateStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
	max-width: 28rem;
`

// Two-column grid for the page-2 detail cards; stacks on narrow widths.
export const TwoCol = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	gap: ${Spacings.SPACING_4B};
`

// Grid of commodity/category cards for "Start Adding Items".
export const ItemGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	gap: ${Spacings.SPACING_3B};
	margin-top: ${Spacings.SPACING_3B};
`

export const CategoryCard = styled.button`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
	min-height: ${Spacings.SPACING_28B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.md};
	background: ${({ theme }) => theme.colors.surface.card};
	cursor: pointer;
	font-family: inherit;
	transition: border-color 0.15s, box-shadow 0.15s;

	&:hover {
		border-color: ${({ theme }) => theme.colors.brand.primary};
		box-shadow: ${({ theme }) => theme.shadows?.sm};
	}
`

export const CategoryName = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.colors.text.primary};
	text-align: center;
`

export const AddBadge = styled.span`
	position: absolute;
	top: ${Spacings.SPACING_2B};
	right: ${Spacings.SPACING_2B};
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${Spacings.SPACING_5B};
	height: ${Spacings.SPACING_5B};
	border-radius: ${({ theme }) => theme.radius.sm};
	border: 1px solid ${({ theme }) => theme.colors.brand.primary};
	color: ${({ theme }) => theme.colors.brand.primary};
	font-weight: ${Text.BOLD_700};
	line-height: 1;
`

// Added order-items list.
export const ItemList = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	margin-top: ${Spacings.SPACING_4B};
`

// Wrapper for the added-items table (spacing below the category grid).
export const ItemsTableWrap = styled.div`
	margin-top: ${Spacings.SPACING_4B};
	min-width: 0;
	max-width: 100%;
`

export const ItemRow = styled.div`
	display: grid;
	grid-template-columns: 1.4fr 1fr 1fr 1fr auto;
	align-items: center;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_3B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.md};
	background: ${({ theme }) => theme.colors.surface.card};
	cursor: pointer;

	&:hover {
		border-color: ${({ theme }) => theme.colors.brand.primary};
	}

	@media (max-width: 640px) {
		grid-template-columns: 1fr 1fr;
	}
`

export const ItemCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1};
`

export const CellLabel = styled.span`
	font-size: ${Text.EXTRA_SMALL};
	text-transform: uppercase;
	letter-spacing: 0.02em;
	color: ${({ theme }) => theme.colors.text.secondary};
`

export const CellValue = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.colors.text.primary};
`

export const EmptyItems = styled.div`
	padding: ${Spacings.SPACING_6B};
	text-align: center;
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.colors.text.secondary};
	border: 1px dashed ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.md};
	margin-top: ${Spacings.SPACING_3B};
`

// Sticky footer with the Back / Continue / Create SPO buttons.
export const Footer = styled.div`
	position: sticky;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.colors.surface.card};
	border-top: 1px solid ${({ theme }) => theme.colors.border.default};
	
	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`

export const FooterRight = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_3B};
	margin-left: auto;
`

// The terms are long boilerplate, so the box still scrolls — it just does not show a scrollbar.
export const TermsTextarea = styled(Textarea)`
	textarea {
		scrollbar-width: none;
		-ms-overflow-style: none;

		&::-webkit-scrollbar {
			width: 0;
			height: 0;
			display: none;
		}
	}
`
